import { useState } from "react";
import { Ellipsis, Link2 } from "lucide-react";
import { toast } from "sonner";
import { z } from "zod";

import { buttonVariants } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { FormRecordPicker } from "components/BaseForm";
import BaseForm from "components/BaseForm/BaseForm";
import CampaignService from "services/Campaign";
import MetaCampaignService from "services/MetaCampaign";

const schema = z.object({
  crm_campaign_id: z.number().nullable(),
});

const fetchCampaigns = search =>
  CampaignService.getCampaignsForFilters(search ? { search } : null);

// Row actions for one mirrored Meta campaign. The CRM-campaign link opens a
// picker; clearing it and saving unlinks. Linking backfills the campaign's Meta
// leads server-side.
const MetaCampaignsTableActions = ({ campaign, accountId, invalidate }) => {
  const [open, setOpen] = useState(false);
  const linked = campaign.crm_campaign_id != null;

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          aria-label="Campaign actions"
          className={buttonVariants({ variant: "ghost", size: "icon-sm" })}
        >
          <Ellipsis />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          <DropdownMenuItem onClick={() => setOpen(true)}>
            <Link2 />
            {linked ? "Change CRM Campaign" : "Link CRM Campaign"}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Link CRM campaign</DialogTitle>
          </DialogHeader>
          <BaseForm
            schema={schema}
            defaultValues={{
              crm_campaign_id: campaign.crm_campaign_id ?? null,
            }}
            onSubmit={values =>
              MetaCampaignService.linkCrmCampaign(
                accountId,
                campaign.id,
                values.crm_campaign_id
              )
            }
            onSuccess={values => {
              invalidate();
              toast.success(
                values.crm_campaign_id != null
                  ? "Campaign linked. Existing leads are being backfilled in the background."
                  : "Campaign unlinked"
              );
              setOpen(false);
            }}
            submitButtonText="Save"
          >
            <FormRecordPicker
              name="crm_campaign_id"
              label="CRM campaign"
              fetchOptions={fetchCampaigns}
              display={
                linked
                  ? {
                      id: campaign.crm_campaign_id,
                      label: campaign.crm_campaign_name,
                    }
                  : undefined
              }
              placeholder="Search campaigns…"
            />
          </BaseForm>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default MetaCampaignsTableActions;
